import {useQuery} from 'react-query';
import getLabDetail from '.';

interface IGetLabDetailProps {
  lab_guid?: string;
  handleAfterSuccess?: (labData: IGetLabDetail) => void;
}

const useGetLabDetail = ({
  lab_guid,
  handleAfterSuccess,
}: IGetLabDetailProps) => {
  const {data, isLoading} = useQuery(
    ['lab-detail'],
    () => getLabDetail(lab_guid),
    {
      enabled: lab_guid ? true : false,
      onSuccess: labData => {
        handleAfterSuccess && handleAfterSuccess(labData);
      },
    },
  );

  return {labData: data, labDataIsLoading: isLoading};
};

export default useGetLabDetail;
